package fr.frux.shared.data.repository

import dev.zacsweers.metro.ContributesBinding
import dev.zacsweers.metro.Inject
import dev.zacsweers.metro.SingleIn
import fr.frux.core.common.di.AppScope
import fr.frux.core.common.entitlements.AccountEntitlements
import fr.frux.core.common.entitlements.EntitlementsHolder
import fr.frux.core.common.entitlements.PremiumSource
import fr.frux.shared.domain.model.PremiumStatus
import fr.frux.shared.domain.repository.AuthRepository
import fr.frux.shared.domain.repository.PremiumRepository
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map
import kotlin.time.Clock

/**
 * Statut Frux+ dérivé de [EntitlementsHolder], que [AuthRepository.getCurrentUser] alimente déjà :
 * pas de second chemin vers `/auth/me`. L'échéance se compare à l'heure du serveur quand elle est
 * connue (#527), jamais à la seule horloge de l'appareil.
 */
@ContributesBinding(AppScope::class)
@SingleIn(AppScope::class)
@Inject
class PremiumRepositoryImpl(
    private val entitlements: EntitlementsHolder,
    private val authRepository: AuthRepository,
) : PremiumRepository {
    override val status: Flow<PremiumStatus> = entitlements.state.map { it.toPremiumStatus() }

    override suspend fun refreshPremiumStatus(): Result<Unit> = authRepository.getCurrentUser().map { }
}

internal fun AccountEntitlements?.toPremiumStatus(): PremiumStatus {
    if (this == null) return PremiumStatus.Unknown
    val now = serverClock?.now() ?: Clock.System.now()
    return if (isPremiumAt(now)) {
        PremiumStatus.Active(expiresAt = premiumExpiresAt, source = premiumSource ?: PremiumSource.OTHER)
    } else {
        PremiumStatus.Free
    }
}
